/**
 * @flow
 * @relayHash c5a99dcc91be2e815ebb46f707d562cb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type uploadCsvInput = {|
  clientMutationId?: ?string,
  propertyId: string,
  name: string,
  csvData: string,
|};
export type uploadCsvMutationVariables = {|
  input: uploadCsvInput
|};
export type uploadCsvMutationResponse = {|
  +uploadCsv: ?{|
    +csvFile: ?{|
      +name: string,
      +tempfile: string,
      +columnNames: $ReadOnlyArray<string>,
      +rowsCount: number,
    |}
  |}
|};
export type uploadCsvMutation = {|
  variables: uploadCsvMutationVariables,
  response: uploadCsvMutationResponse,
|};
*/


/*
mutation uploadCsvMutation(
  $input: uploadCsvInput!
) {
  uploadCsv(input: $input) {
    csvFile {
      name
      tempfile
      columnNames
      rowsCount
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "uploadCsvInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tempfile",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "columnNames",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rowsCount",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "uploadCsvMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "uploadCsv",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "uploadCsvPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "csvFile",
            "storageKey": null,
            "args": null,
            "concreteType": "CsvFile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "uploadCsvMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "uploadCsv",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "uploadCsvPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "csvFile",
            "storageKey": null,
            "args": null,
            "concreteType": "CsvFile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "uploadCsvMutation",
    "id": null,
    "text": "mutation uploadCsvMutation(\n  $input: uploadCsvInput!\n) {\n  uploadCsv(input: $input) {\n    csvFile {\n      name\n      tempfile\n      columnNames\n      rowsCount\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '599cb59435fccaaa170d5f09cbe4920b';
module.exports = node;
